import { Chart } from './Chart.js'

class BarChart extends Chart {
  type = 'bar'

  options = {
    ...this.options,
    toolbar: {
      show: true,
      tools: {
        download: true
      }
    },
    colors: [
      '#5b21b6', //cyan bleu
      '#fbca28', //yellow
      '#f15bb5', //pink
      '#9b5de5', //purple
      '#5CD433', //green
      '#334ED4', //dark blue
      '#D43333', //red
      '#DC7633', //orange
      '#808B96', //grey
      '#3498DB' // sky blue
    ],
    plotOptions: {
      bar: {
        borderRadius: 10,
        horizontal: false,
        distributed: false,
        dataLabels: {
          position: 'top' // top, center, bottom
        }
      }
    },
    dataLabels: {
      enabled: true,
      formatter: function (val) {
        return `${val}%`
      },
      offsetY: -20,
      style: {
        fontSize: '12px',
        colors: ['#304758']
      }
    },
    xaxis: {
      categories: [],
      position: 'bottom',
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      tooltip: {
        enabled: false
      }
    },
    yaxis: {
      axisBorder: {
        show: false
      },
      axisTicks: {
        show: false
      },
      labels: {
        show: false,
        formatter: function (val) {
          return `${val}%`
        }
      }
    }
  }

  series = []
  setSeries(series) {
    this.series = series
  }

  setCategories(categories: any[]) {
    this.options = {
      ...this.options,
      ...{
        xaxis: {
          ...this.options.xaxis,
          categories: categories
        }
      }
    }
  }

  distribute() {
    this.options = {
      ...this.options,
      plotOptions: {
        ...this.options.plotOptions,
        bar: {
          ...this.options.plotOptions.bar,
          distributed: true
        }
      }
    }
  }

  stack() {
    this.options = {
      ...this.options,
      ...{
        chart: {
          type: 'bar',
          stacked: true,
          stackType: '100%'
        },
        dataLabels: {
          ...this.options.dataLabels,
          offsetY: 0,
          formatter: null,
          style: {
            ...this.options.dataLabels.style,
            fontSize: '10px',
            colors: ['#fff']
          }
        }
      }
    }
  }

  horizontal() {
    this.options = {
      ...this.options,
      plotOptions: {
        ...this.options.plotOptions,
        bar: {
          ...this.options.plotOptions.bar,
          borderRadius: 4,
          horizontal: true
        }
      },
      dataLabels: {
        ...this.options.dataLabels,
        enabled: false
      },
      yaxis: {
        ...this.options.yaxis,
        labels: {
          ...this.options.yaxis.labels,
          show: true,
          formatter: function (val) {
            return val
          }
        }
      }
    }
  }
}

export { BarChart }
